/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Input, Empty, DatePicker, message } from 'antd'
// import './index.scss'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import SubscribeProgress from '../subscribeProgress'

const { RangePicker } = DatePicker
const dateFormat = 'lll'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			dateRange: [],
			isExporting: false,
			exportProgress: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { user_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText, dateRange = [],
			isExporting, exportProgress
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		if (dateRange.length > 0) {
			const startDate = moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
			const endDate = moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
			filters = Object.assign({}, filters, {
				date_start: startDate,
				date_end: endDate
			})
		}
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<Col md={6} sm={24}>
							{
								(dateRange.length > 0) &&
								<button 
									type="button" 
									className="btn btn-outline-success btn-rounded waves-effect waves-light"
									onClick={() => {
										const { exportVisitorLogs } = this.props
										const params = {
											date_start: moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
											date_end: moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss'),
											searchText: searchText
										}
										exportVisitorLogs(params)
									}}
								>
									<i className='mdi mdi-file-excel'/> Export in Excel
								</button>
							}
						</Col>
						<Col md={18} sm={24}>
							<Row style={{ textAlign: 'right' }}>
								<RangePicker
									showTime
									format={dateFormat}
									style={{ marginRight: 20, width: 400 }}
									onChange={(value) => {
										// console.log('range picker value', value)
										this.setState({ dateRange: value })
									}}
								/>
								<Input 
									style={{ width: 300 }}
									placeholder='Search Here..' 
									onChange={(e)=>{
										this.setState({ searchText: e.target.value })
									}}/>
							</Row>
						</Col>
					</Row>
					<br />
					<Row>
						<Query query={VISITOR_LOGS} variables={{ searchFilter: filters }}>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let visitorLogs = _.has(data,'visitorLogs') ? data.visitorLogs.data : []
								visitorLogs = visitorLogs.map((visitorLog, key) => Object.assign({}, visitorLog, { key }))
								let _pagination = _.has(data, 'visitorLogs') ? data.visitorLogs.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
										title: 'Full Name',
										key: 'full_name',
										dataIndex: 'full_name'
									}, {
										title: 'Contact Number',
										key: 'mobile_number',
										dataIndex: 'mobile_number'
									}, 
									//{
									//	title: 'Email',
									//	key: 'email',
									//	dataIndex: 'email'
									//}, 
									{
										title: 'Purpose',
										key: 'purpose_visit',
										dataIndex: 'purpose_visit'
									}, {
										title: 'Log Date',
										key: 'log_date',
										render: (item) => {
											return (
												<span>{moment(item.log_date).format('LLLL')}</span>
											)
										}
									}, {
										title: 'Address',
										key: 'address',
										dataIndex: 'address'
									}, ]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: 'visitor-logs' },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={visitorLogs} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
				</Col>
			</Row>
		)
	}
}

const VISITOR_LOGS = gql`
    query visitorLogs($searchFilter: SearchParams) {
		visitorLogs(searchFilter: $searchFilter)
    }
`

const EXPORT_VISITOR_LOGS = gql`
    mutation exportVisitorLogs($input: JSON) {
		exportVisitorLogs(input: $input)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const composed = compose(
	inject('AuthStore'),
	graphql(EXPORT_VISITOR_LOGS, {
		props({ mutate }) {
			return {
				exportVisitorLogs(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
